import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Typography, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { toaster } from "components/common/Toast"
import { saveAIDashboardChartFromChat } from "store/aiDashboard"
import styles from "../style.module.css"

const { Text } = Typography

export default function AddChartPrompt({ payload, dispatch, onSaved, onDismiss }) {
  const { t } = useTranslation()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  const handleSave = () => {
    setSaving(true)
    setError(null)
    dispatch(saveAIDashboardChartFromChat({
      source_prompt: payload.source_prompt,
      chart_type: payload.chart_type
    }))
      .then(() => {
        toaster.success(t("ai_dashboard.chart_saved"))
        onSaved?.()
      })
      .catch((err) => {
        const apiError = err?.data?.error
        if (err?.status === 409) {
          setError(apiError || t("ai_dashboard.chart_already_saved"))
        } else {
          toaster.error(apiError || t("ai_dashboard.chart_save_failed"))
        }
        setSaving(false)
      })
  }

  return (
    <div className={styles.chatChartPrompt}>
      <Text strong className={styles.chatChartPromptText}>{t("ai_dashboard.add_chart_prompt")}</Text>
      {error && <Text type="danger" className={`${styles.textSm} ${styles.chatChartPromptText}`}>{error}</Text>}
      <Flex gap={8} className={styles.chatChartActions}>
        <Button shape="round" loading={saving} onClick={handleSave}>{t("ai_dashboard.yes_add")}</Button>
        <Button shape="round" onClick={onDismiss} disabled={saving}>{t("ai_dashboard.no_thanks")}</Button>
      </Flex>
    </div>
  )
}

AddChartPrompt.propTypes = {
  payload: PropTypes.object,
  dispatch: PropTypes.func,
  onSaved: PropTypes.func,
  onDismiss: PropTypes.func,
}
